import { AlertCircle } from "lucide-react";

/**
 * A measure row's problem (measures-self-service D3, D14, D17): an icon and
 * the text, announced as an alert, never colour alone. Shared by the
 * datasource measures editor and both report-builder measure editors.
 */
export function MeasureRowError({
  id,
  message,
  className = "",
  testId = "measure-row-error",
}: {
  id?: string;
  message: string;
  className?: string;
  testId?: string;
}) {
  return (
    <p
      id={id}
      role="alert"
      data-testid={testId}
      className={`flex items-start gap-1.5 text-xs text-red-700 ${className}`}
    >
      <AlertCircle className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      <span>{message}</span>
    </p>
  );
}
